module.exports = __webpack_public_path__ + "static/media/exit-symbol.672a3727.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/exit-symbol.svg
// module id = 211
// module chunks = 0